<template>
  <div class="mt-2">
    <vue-editor
        v-model="content"
        :editorToolbar="customToolbar"
        @text-change="onChange"
        :placeholder="label"
    ></vue-editor>
    <!-- <pre>{{ content }}</pre> -->
    <div class="d-flex pt-2" v-if="!hideActions">
        <v-spacer></v-spacer>
        <v-btn small class="ml-2"
            depressed
            @click="onCancel"
        >Cancel</v-btn>
        <v-btn small class="ml-2"
            depressed
            color="accent" dark
            @click="onSave"
        >Save</v-btn>
    </div>
  </div>
</template>
<script>
// import { VueEditor } from 'vue2-editor';

export default {
  name: 'issue-desc',
  // components: {
  //   VueEditor,
  // },
  props: {
    value: {
      type: String,
      default() {
        return null;
      },
    },
    hideActions: Boolean,
    label: String,
  },
  model: {
    event: 'modified',
  },
  data() {
    return {
      content: this.value,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ size: ['small', false, 'large'] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block', 'link'],
        ['clean'],
      ],
    };
  },
  methods: {
    onSave() {
      this.$emit('save', this.content);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onChange() {
      this.$emit('change', this.content);
    },
  },
};
</script>
